import React, { useEffect, useState } from "react";
import DTOEmergencyContactModal from "./DTOEmergencyContactModal";
import EmergencyContactModalPresenter from "./EmergencyContactModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { emergencyContactType } from "../../../interfaces/myProfile/personalDetails/emergencyContactType";
import { updatePersonalDetailsService } from "../../../../api/services/updatePersonalDetailsService";
import { getEmergencyDetailReducer } from "../../../../infra/aggregates/myProfile/emergencyContactSlice";
import toast from "react-hot-toast";
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  isCardUpdate: (data: boolean) => void;
  trans?: any;
}

const EmergencyContactModalController = ({
  isModalOpen,
  closeModal,
  isCardUpdate,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.emergencyContactSlice);
  const empId = useAppSelector((state) => state?.authSlice?.emp_id);
  const dispatch = useAppDispatch();

  const [allCountriesData, setAllCountriesData] = useState<[]>([]);

  const getData = (emergency_contact_data: emergencyContactType) => {
    updateEmergencyContactDetail(emergency_contact_data);
  };
  let emergency_contact_data: emergencyContactType = {
    emergencyContactNumber: 0,
    emergencyPersonName: "",
    emergencyCountry: "",
    emergencyEmail: "",
    emergencyRelationship: "",
  };
  async function updateEmergencyContactDetail(data: emergencyContactType) {
    const payload = {
      emp_id: empId,
      full_name: data.emergencyPersonName,
      phone_number: data.emergencyContactNumber,
      email: data.emergencyEmail,
      relationship: data.emergencyRelationship,
      country: data.emergencyCountry,
      locale: localStorage.getItem("emplang"),
    };
    updatePersonalDetailsService
      .updateEmergencyContact(payload)
      .then((response: any) => {
        if (response.status == "success") {
          const { data }: any = response;
          emergency_contact_data = {
            emergencyContactNumber: data?.emergency_contact,
            emergencyPersonName: data?.emergency_person,
            emergencyCountry: data?.emergency_country,
            emergencyEmail: data?.emergency_email,
            emergencyRelationship: data?.emergency_relationship,
          };

          dispatch(getEmergencyDetailReducer(emergency_contact_data));
          isCardUpdate(true);
          closeModal();
          toast.success(response?.msg);
        }
      })
      .catch((err) => {
        const _errors = Object.keys(err?.response?.data?.errors);
        toast.error(`${_errors.toString().toUpperCase()} Required!`);
      });
  }

  function getAllCountries(countries: []) {
    setAllCountriesData(countries);
  }
  return (
    <div>
      <DTOEmergencyContactModal setAllCountries={getAllCountries} />

      <EmergencyContactModalPresenter
        callBackHandleClockIn={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        selectedEmployeeDetail={selector}
        allCountriesData={allCountriesData}
        trans={trans}
      />
    </div>
  );
};

export default EmergencyContactModalController;
